import * as contract from '@tableau/hybrid-widgets-contract';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { MenuComponent, RejectFunc, ResolveFunc } from './MenuComponent';

export class MenuImpl implements contract.MenuAPI {
  public Show(config: contract.Configuration, menuItems: Array<contract.MenuItem>): Promise<contract.MenuEntry> {
    return new Promise((resolve: ResolveFunc, reject: RejectFunc) => {
      const mountPoint = document.createElement('div');
      document.body.appendChild(mountPoint);
      const cleanUp = () => {
        ReactDOM.unmountComponentAtNode(mountPoint);
        document.body.removeChild(mountPoint);
      };

      ReactDOM.render(
        <MenuComponent
          configuration={config}
          menuItems={menuItems}
          resolve={selectedEntry => {
            cleanUp();
            resolve(selectedEntry);
          }}
          reject={reason => {
            cleanUp();
            reject(reason);
          }}
        />,
        mountPoint,
      );
    });
  }
}

export const Instance: MenuImpl = new MenuImpl();
